module.exports = __webpack_public_path__ + "static/media/1_1.1e91dfba.png";